import {Tooltip} from 'antd';
import React, {FC, MouseEvent} from 'react';

import {createActionGetFile} from 'modules/data/data-actions';
import {ECommonMessages} from 'shared/constants/messages';
import {ERequestType} from 'shared/types/requests';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectMicroserviceToken} from 'store/slices/auth-slice/auth-slice-selectors';

import c from './file-with-token.module.less';

interface IFileWithTokenProps {
    url: string;
}

export const FileWithToken: FC<IFileWithTokenProps> = ({url}: IFileWithTokenProps) => {
    const dispatch = useAppDispatch();
    const token = useAppSelector(selectMicroserviceToken);

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        if (!token) {
            console.error('Токен не найден, выполнение запроса невозможно');
            return;
        }

        dispatch(createActionGetFile({
            referenceUrl: url,
            requestType: ERequestType.GET,
            headers: {Authorization: token},
            requestMessages: {
                successMessage: ECommonMessages.UPLOAD_FILE_SUCCESS,
            },
        }));
    };

    return token ? (
        <a
            href={url}
            onClick={handleClick}
        >{url}
        </a>
    ) : (
        <Tooltip
            title="Токен не найден, ссылка неактивна"
            mouseEnterDelay={0.3}
        >
            <span className={c.disabled}>
                {url}
            </span>
        </Tooltip>
    );
};
